/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('../bootstrap');
window.apiEndPoint = '/api/sen';
window.mediaRoot = `https://media.goodschool.hk`;
window.mediaAPI = `https://media.goodschool.hk/api/media`;



window.Vue = require('vue');

var VueCookie = require('vue-cookie');
Vue.use(VueCookie);

window.moment = require('moment');
window.CryptoJS = require('crypto-js');
window.CryptoJSAesJson = require('../secret/aes-json-format.js');
if (!CryptoJS) {
    alert("not support cryptojs");
}

window.Popper = require('popper.js').default;
try {
    window.$ = window.jQuery = require('jquery');
    require('bootstrap3');
    require('@fortawesome/fontawesome-free');
} catch (e) {}

import vSelect from 'vue-select'
Vue.component('v-select', vSelect);


// import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
// import bTooltip from 'bootstrap-vue/es/components/tooltip/tooltip';
// Vue.component('b-tooltip', bTooltip);
// Vue.component('b-pagination', bPagination);

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);





Vue.component('sen-school-list', require('./SenSchoolList'))
Vue.directive('readed-article', require('../shared/directive/ViewDetailPage'));



const app = new Vue({
    el: '#app'
});


// WEBPACK FOOTER //
// ./resources/js/sen-school/sen-school.js